import React, { useState, useEffect, useRef } from "react";
import { TableContainer, Paper, Typography, Box, Grid } from "@mui/material";
import { api, get, post } from "../../../../utils/api";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../utils/companyId";
import Add from "./Add";
// import View from "./View";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Cards from "../../../../Components/Common/Cards";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { getMonthName } from "../../../../utils/getMonthName";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import { truncateNumber } from "../../../../utils/common";
import Scope4Layout from "../../../../Layout/Scope4Layout";
import View from "../RenawableEnergyExports/View";
import FugitiveBulkUpload from "../../../Scope1/FugitiveEmmissions/FugitiveBulkUpload";
import { useUser } from "../../../../context/AuthContext";
import {
  facilityDataCellSx,
  getFacilityName,
  GRID_TABLE_ACTION_COL,
  getGridTableRowSx,
  gridTableActionHeaderSx,
  gridTablePaperSx,
  isFacilityHeading,
  shouldShowFacilityColumn,
  withFacilityHeading,
} from "../../../../utils/facilityColumn";
// import BulkUpload from "../NaturalGas/BulkUpload";

const LowCarbonProductUse = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? `minmax(0, 0.9fr) minmax(0, 1.1fr) minmax(0, 1fr) minmax(0, 1.1fr) minmax(0, 1.1fr) minmax(0, 1.1fr) ${GRID_TABLE_ACTION_COL}`
    : `minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1.3fr) ${GRID_TABLE_ACTION_COL}`;
  const [selectedDate, setSelectedDate] = useState({});
  const [cardData, setCardData] = useState(null);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Month of Product Sold": false,
    // "Industrial Process": false,
    "Product Name": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    "Quantity Consumed": false,
    "Hours Used": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    productName: [],
  });

  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);

  const [bulkUploadTable, setBulkUploadTable] = useState(true);

  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [matchData, setMatchData] = useState([]);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    startMonth: null,
    endMonth: null,
    productName: [],
  });

  let bannerData = [
    {
      title: "Total Product Sold",
      description: truncateNumber(cardData?.total),
      // unit: cardData?.total?.unit,
    },
    {
      title: "Top Sold Product",
      description:
        cardData?.topProjectTypes?.length > 0
          ? cardData?.topProjectTypes.map((el) => el.productName)
          : "N/A",
    },
    {
      title: "Quantity Sold Month ",
      description: truncateNumber(cardData?.monthly?.totalquantitySold),
      // unit: cardData?.monthly?.unit || "",
      filter: "date",
      defaultValue: {},
    },
  ];

  const fetchExcelData = async () => {
    await get("/scope4/lower-carbon-product/exportExcel")
      .then((res) => {
        let data = res?.data?.data;
        let arr = [];
        data &&
          data.forEach((el, idx) => {
            arr.push({
              "Month (in 01/25 or Jan-25)": "",
              "Product name": "",
              "Quantity sold": "",
              "Unit of product sold (Pcs,Item)": "",
              "Emission factor of product sold": "",
              "Conventional product name": "",
              "Emission factor of Conventional product": "",
              "Remark (optional)": "",
            });
          });
        setExcelData(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const fetchCardData = async (month, year) => {
    try {
      console.log(month, year, selectedMonth, selectedYear);
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
      const response = await get(
        `/scope4/lower-carbon-product/cardData?year=${
          selectedYear ? selectedYear : currentYear
        }&month=${selectedMonth ? selectedMonth : currentMonth + 1}`
      );
      console.log(response.data, "data");
      setCardData(response.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [selectedMonth, selectedYear]);

  const handlePeriodChange = (key, value, filterType) => {
    const [year, month] = value.split("-");
    setSelectedDate((prev) => ({
      ...prev,
      month,
      year,
    }));
    fetchCardData(year, month, "");
  };

  const filters = ["Date", "Month of Product Sold", "Product Name"];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Month of Product Sold",
      required: true,
      type: "date",
    },
    {
      fieldName: "productName",
      title: "Product name ",
      placeholder: "Enter product name",
      type: "text",
      required: true,
    },
    // {
    //   fieldName: "quantitySold",
    //   title: "Quantity sold",
    //   placeholder: "Enter quantity",
    //   type: "number",
    //   // options: ["Cumulative", "Individual"],
    //   required: true,
    // },

    {
      fieldName: "unitValue",
      title: "Quantity sold",
      placeholder: "Enter quantity",
      type: "number",
      required: true,
    },
    {
      fieldName: "unit",
      title: "Unit value of sold product",
      placeholder: "Select unit",
      type: "select",
      options: ["MT","KL", "Item"],
      required: true,
      // adornmentText: "MT",
      // options: ["MT", "Kg"],
    },
    {
      fieldName: "emissionFactorProductSold",
      title: "Emission factor of product sold",
      placeholder: "Enter emission factor",
      type: "number",
      required: true,
    },

    {
      fieldName: "conventionalProductName",
      title: "Conventional product name",
      placeholder: "Enter conventional product name",
      type: "text",
      required: true,
    },
    {
      fieldName: "emissionFactorConventionalProduct",
      title: "Emission factor of Conventional product",
      placeholder: "Enter emission factor",
      type: "number",
      required: true,
    },

    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const onConfirm = async () => {
    try {
      const excelData = Object.values(formDataBulkUpload).map((item) => {
        const selected = String(
          item?.["Unit of sold product"] ||
            item?.unit ||
            item?.["Unit of product sold"] ||
            item?.["Unit of product sold (Pcs,Item)"] ||
            ""
        ).trim();
        return {
          ...item,
          unit: selected,
          "Unit of product sold": selected,
          "Unit of sold product": selected,
          "Unit of product sold (Pcs,Item)": selected,
        };
      });
      const response = await post(`/scope4/lower-carbon-product/jsonupload`, {
        excelData,
      });
      setBulkUploadTable(false);
      fetchData();
      setsnackOpen({
        open: true,
        message: "Bulk upload completed successfully!",
        severity: "success",
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope4/lower-carbon-product/get?limit=null`);
      const data = response.data.data;

      const uniqueProductName = [
        ...new Set(data.map((el) => el.productName).filter(Boolean)),
      ];

      return { productName: uniqueProductName };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };
  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {},
    pageNumber = page
  ) => {
    fetchCardData(selectedMonth, selectedMonth);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page: pageNumber ? pageNumber : page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope4/lower-carbon-product/get?${queryParams}`
      );
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM")
      : "",
    productName: tempFilter?.productName || "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Equipment Type": false,
    };

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      productName: tempFilter?.productName || [],
    });

    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    fetchData(filtersToApply, 1);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      productName: [],
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      productName: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isProductNameApplied = tempFilter?.productName?.length > 0;

    setIsFiltersApplied(
      isDateApplied || isMonthApplied || isProductNameApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Month of Product Sold": isMonthApplied,
      "Product Name": isProductNameApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      equipmentType: selectedFields.equipmentType,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = withFacilityHeading(
    [
      { title: "Date", fieldName: "createdAt" },
      { title: "Month of Product Sold", fieldName: "consumptionPeriod" },
      { title: "Product name ", fieldName: "productName" },
      { fieldName: "unitValue", title: "Quantity sold" },
      { fieldName: "unit", title: "Unit of sold product" },
    ],
    showFacilityColumn
  );

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Month of Product Sold":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
            title="Month of Product Sold"
          />
        );

      case "Product Name":
        return (
          <MultiSelect
            title="Product Name"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  productName: newValue.productName || newValue,
                };
              });
            }}
            setErrors={setErrors}
            field="productName"
            data={uniqueValues.productName || []}
          />
        );
      default:
        return null;
    }
  };
  const UNIT_OPTIONS = ["Pcs", "Item"];
  const UNIT_EXCEL_KEY = "Unit of product sold (Pcs,Item)";
  const withUnitMatch = (rows) =>
    (Array.isArray(rows) ? rows : Object.values(rows || {})).map((item) => {
      const unit = String(
        item?.unit ??
          item?.[UNIT_EXCEL_KEY] ??
          item?.["Unit of product sold"] ??
          item?.["Unit of sold product"] ??
          ""
      ).trim();
      const matched = UNIT_OPTIONS.includes(unit);
      return {
        ...item,
        unit,
        matched,
        ...(matched
          ? {
              [UNIT_EXCEL_KEY]: unit,
              "Unit of sold product": unit,
              "Unit of product sold": unit,
            }
          : {}),
      };
    });

  /** Keep selected Master Data unit on excel/API keys so jsonupload receives it. */
  const syncSelectedUnit = (data) => {
    const mapItem = (item = {}) => {
      const selected = String(
        item?.["Unit of sold product"] ||
          item?.unit ||
          item?.[UNIT_EXCEL_KEY] ||
          item?.["Unit of product sold"] ||
          ""
      ).trim();
      if (!selected) return item;
      return {
        ...item,
        unit: selected,
        [UNIT_EXCEL_KEY]: selected,
        "Unit of product sold": selected,
        "Unit of sold product": selected,
      };
    };
    if (Array.isArray(data)) return data.map(mapItem);
    if (data && typeof data === "object") {
      return Object.fromEntries(
        Object.entries(data).map(([k, v]) => [k, mapItem(v)])
      );
    }
    return data;
  };

  const handleBulkFormData = (updater) => {
    setFormDataBulkUpload((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      return syncSelectedUnit(next);
    });
  };

  const uploadErrorClose = () => {
    setBulkUploadTable(true);
  };

  return (
    <MainDashboardLayout sidebar={<Scope4Layout />}>
      <Unauthorized requiredModule="Environment | Scope 4 | Carbon Avoidance | LowerCarbonProduct">
        <Box
          sx={{
            backgroundColor: "#ededed",
            width: "100%",
            minWidth: 0,
            overflow: "hidden",
            boxSizing: "border-box",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <Add
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            title="Data"
            addUrl={`${api}/scope4/lower-carbon-product/add`}
            updateUrl={`${api}/scope4/lower-carbon-product/update`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <View
            id={element ? element._id : ""}
            data={element}
            title={"Low-carbon Product Use / Cleaner Alternatives"}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <Cards
            data={bannerData}
            title={"Carbon Avoidance"}
            onFilterChange={handlePeriodChange}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
            }}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/scope4/lower-carbon-product/delte`,
                setsnackOpen,
                fetchData,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {/* <Toolbar sx={{ padding: "0 16px", marginBottom: "20px" }}> */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              // heading: "Coal",
              setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {/* </Toolbar> */}
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ ...gridTablePaperSx, overflowX: "hidden" }}
          >
            <Box sx={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
              <TableHeading
                heading={"Low-carbon Product Use / Cleaner Alternatives"}
              />
              <Box
                sx={{
                  ...getGridTableRowSx(columnWidth, showFacilityColumn),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) =>
                  isFacilityHeading(el) ? (
                    <Typography
                      key={el.fieldName}
                      sx={{
                        ...facilityDataCellSx,
                        fontWeight: "bold",
                        color: "inherit",
                      }}
                    >
                      {el.title}
                    </Typography>
                  ) : (
                    <ColumnHeadings
                      key={el.fieldName}
                      {...{
                        title: el.title,
                        key: el.title,
                        handleSort,
                        field: el.fieldName,
                        sortConfig,
                      }}
                    />
                  )
                )}
                <Typography sx={gridTableActionHeaderSx}>
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      ...getGridTableRowSx(columnWidth, showFacilityColumn),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) =>
                      isFacilityHeading(el) ? (
                        <Typography key={el.fieldName} sx={facilityDataCellSx}>
                          {getFacilityName(item) || "N/A"}
                        </Typography>
                      ) : (
                        <TableContent
                          key={el.fieldName}
                          {...{
                            fieldData:
                              el.fieldName === "consumptionPeriod"
                                ? getMonthName(item[el.fieldName]?.month) +
                                  " " +
                                  item[el.fieldName]?.year
                                : el.fieldName === "quantityConsumed"
                                ? truncateNumber(item[el.fieldName].value) +
                                  " " +
                                  item[el.fieldName].unit
                                : typeof item[el.fieldName] === "object" &&
                                  item[el.fieldName] !== null &&
                                  item[el.fieldName].industryProcess
                                ? item[el.fieldName].industryProcess
                                : typeof item[el.fieldName] === "object" &&
                                  item[el.fieldName] !== null &&
                                  item[el.fieldName].name
                                ? item[el.fieldName].name
                                : item[el.fieldName],
                            dateField:
                              el.fieldName === "createdAt"
                                ? item.createdAt
                                : false,
                          }}
                        />
                      )
                    )}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>

        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            setsnackOpen={setsnackOpen}
            excelData={excelData}
            setFormDataBulkUpload={(rows) =>
              setFormDataBulkUpload(withUnitMatch(rows))
            }
            formDataBulkUpload={formDataBulkUpload}
            setMatchData={(rows) => setMatchData(withUnitMatch(rows))}
            errorClose={uploadErrorClose}
            matchedKey="statusList"
            // setBulkUploadTable={setBulkUploadTable}
            // setJsonBulkUpload={setJsonBulkUpload}
            fetchData={fetchData}
            setBulkUploadModal={setBulkUploadModal}
            fileName={"Lower-carbon-product"}
            url={"/scope4/lower-carbon-product/bulkupload"}
          />
        )}
        {bulkUploadTable && (
        <FugitiveBulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          formDataBulkUpload={formDataBulkUpload}
          setFormDataBulkUpload={handleBulkFormData}
          addNew={false}
          title1="Unit of sold product"
          keyValue1="unit"
          options1={UNIT_OPTIONS}
          matched1={"matched"}
          onConfirm={onConfirm}
          jsonBulkUpload={formDataBulkUpload}
          bulkUploadUrl="/scope4/lower-carbon-product/jsonupload"
          setsnackOpen={setsnackOpen}
          fieldName="Unit of sold product"
        />
      )}
       
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default LowCarbonProductUse;
